import React from "react";
import { Link } from "react-router-dom";
import "./Card.css";
import convertNumber from "../../helpers/convertNumber";

const Card = (props) => {
  return (
    <>
      <div className="card-container">
        {props.data &&
          props.data[0]?.data_tv?.map((element, i) => (
            <Link
              key={i}
              to={{ pathname: `/detail/${element.tv}` }}
              style={{ textDecoration: "none", color: "white" }}
            >
              <div className="card-container-content">
                <div className="logo-title">
                  <img src={element.logo} alt="" height="50px" />
                </div>
                <div className="card-content">
                  {element.view === "0" ? (
                    // <span>Not Found</span>
                    <span>0 views</span>
                  ) : (
                    <span>{convertNumber(element.view)} views</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
      </div>
    </>
  );
};

export default Card;
